import { pixels, SkeletonBlock, SkeletonRegion } from "@baton/ui";

/**
 * FR-015-090, `contracts/design-system.md` § The shell: the chrome's loading placeholders, in
 * the Skeleton primitive's chrome tone so nothing light paints on the dark frame. Each takes the
 * geometry of what it stands in for: the switcher's raised 40 px card with its 22 px mark, a
 * branch's entry rows at the row height (2026-09-17), and the actor card's 36 px avatar beside
 * the name and email.
 */
export function SwitcherPlaceholder() {
  return (
    <SkeletonRegion className="b-sidebar__switcher b-sidebar__placeholder-card">
      <SkeletonBlock tone="chrome" className="b-sidebar__placeholder-mark" />
      <SkeletonBlock tone="chrome" className="b-sidebar__placeholder-name" />
    </SkeletonRegion>
  );
}

export function ActorPlaceholder() {
  return (
    <div className="b-sidebar__footer">
      <SkeletonRegion className="b-sidebar__placeholder-actor">
        <SkeletonBlock tone="chrome" className="b-sidebar__placeholder-avatar" />
        <span className="b-sidebar__actor-text">
          <SkeletonBlock tone="chrome" className="b-sidebar__placeholder-label" />
          <SkeletonBlock tone="chrome" className="b-sidebar__placeholder-label" />
        </span>
      </SkeletonRegion>
    </div>
  );
}

/** The rows a branch's placeholder draws when the branch has never drawn its entries here. */
const FIRST_ROWS = 2;

/**
 * Entry rows under a branching row (Sprints, Projects) while its list loads: as tall as the branch last
 * drew its entries in this workspace, so a reload moves no row under it when they arrive (the owner's
 * meeting of 2026-09-30), and two rows when it never has. The rows fill that height and are clipped to it.
 */
export function EntriesPlaceholder({ height }: { readonly height?: number | undefined }) {
  const rows = height === undefined ? FIRST_ROWS : Math.max(1, Math.ceil(height / pixels("sidebar-row-height")));
  const region = (
    <SkeletonRegion className="b-sidebar__entries-placeholder">
      {Array.from({ length: rows }, (_, index) => (
        <div key={index} className="b-sidebar__placeholder-row">
          <SkeletonBlock tone="chrome" className="b-sidebar__placeholder-label" />
        </div>
      ))}
    </SkeletonRegion>
  );
  if (height === undefined) return region;
  return (
    <div className="b-sidebar__entries-reserve" style={{ blockSize: `${height}px` }}>
      {region}
    </div>
  );
}
